<template>
  <el-input size="medium" v-model="changeValue" v-bind="{ ...item }" placeholder="自动生成随机编号" disabled readonly />
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'TRandomNumber',
  mixins: [mixin]
}
</script>

<style scoped></style>
